export default function urlBase64ToUint8Array(
  base64String: string,
): Uint8Array {
  const padding: string = "=".repeat((4 - (base64String.length % 4)) % 4)
  const base64: string = (base64String + padding)
    .replace(/\-/g, "+")
    .replace(/_/g, "/")

  const rawData: Buffer = Buffer.from(base64, "base64")

  const outputArray: Uint8Array = new Uint8Array(rawData.length)
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData[i]
  }
  return outputArray
}
